import { render, staticRenderFns } from "./LocationAttributeSelect.vue?vue&type=template&id=24e20f24&scoped=true&"
import script from "./LocationAttributeSelect.vue?vue&type=script&lang=js&"
export * from "./LocationAttributeSelect.vue?vue&type=script&lang=js&"
import style0 from "./LocationAttributeSelect.vue?vue&type=style&index=0&id=24e20f24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e20f24",
  null
  
)

export default component.exports